/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { userListConfig } from '../../config/userLists.config';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_REJECTED_APPLICATIONS } from '../../api/graphql';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { vappContainer } from '@/application';
import { Graphql } from '@common/graphql';
import { AppNavigatorService } from '@/AppNavigator';
import { apiConfig } from '@/config/apiConfig';
import { APPLICATION_TYPE } from '@/config/applicationType.config';

export interface IRejectedApplicationsMethods extends IPluginMethodMap {
  getRejectedApplications(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class RejectedApplicationsService implements IAgentPlugin {
  readonly methods: IRejectedApplicationsMethods;

  constructor() {
    this.methods = {
      getRejectedApplications: this.getRejectedApplicationsProps.bind(this),
    };
  }

  async getRejectedApplicationsProps(args: any) {
    console.log(`getRejectedApplicationsProps args`, args);
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    console.log('data in query', args);
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    const userProfile = storageService.get('myProfile', 'session');
    const role = userProfile?.org?.orgRole;
    const whoAmI =
      userData?.currentRole ??
      (userData?.userRoles && Array.isArray(userData?.userRoles)
        ? userData?.userRoles[0]?.name
        : null);
    const roetable = [
      {
        column: 'type',
        op: 'In',
        value: ['CARICOM_RENEW_WORK_PERMIT','CARICOM_NEW_WORK_PERMIT'],
      },
    ];
    const where =
      args?.where?.length > 1
        ? args?.where
        : [
            ...(args?.where ?? []),
            ...(role === 'CARICOM_BUSSINESS_ORG' ? roetable : []),
            {
              column: 'status',
              op: 'In',
              value: ['APPLICATION_DENIED', 'APPEALED'],
            },
          ];
    try {
      console.log('where->', where);
      if (client) {
        const statusValue = ['APPLICATION_DENIED', 'APPEALED'];

        const res = await client.query(GET_REJECTED_APPLICATIONS, {
          input: {
            where: where,
            order: [
              {
                column: 'updatedAt',
                direction: 'DESC',
              },
            ],
            limit: args?.size,
            skip: args?.offset,
          },
        });
        if (res?.data) {
          console.log(`table data2`, res);
          let _rowData = this.formatUserTable(
            res?.data?.getListOfApplication?.data
          );
          console.log(`row data`, _rowData);
          return {
            ...userListConfig,
            ultUsers: _rowData,
            //userRoles: res?.data?.getRoleList?.data,
            isEmpty: _rowData
              ? res?.data?.getListOfApplication?.data?.length <= 0
              : true,
            // studentGroup: holderGroups,
            activePage: res?.data?.getListOfApplication?.currentPage,
            pageSize: res?.data?.getListOfApplication?.pageSize,
            totalCount: res?.data?.getListOfApplication?.totalCount,
            totalPages: res?.data?.getListOfApplication?.totalPages,
          };
        } else {
          console.log('hiii', res);
          if (res?.error) {
            return {
              error: true,
              isEmpty: true,
            };
          }
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        error: true,
        isEmpty: true,
      };
    }
  }

  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any, index: number) => {
        return {
          data: item,
          id: item?._id,
          // name: item?.applicantInfo?.firstName
          //   ? `${
          //       item?.applicantInfo?.lastName
          //         ? toHeaderCase(item?.applicantInfo?.lastName ?? '')
          //         : ''
          //     }, ${toHeaderCase(item?.applicantInfo?.firstName)}`
          //   : // ${
          //     //     item?.applicantInfo?.middleName
          //     //       ? toHeaderCase(item?.applicantInfo?.middleName ?? '')
          //     //       : ''
          //     //   }`
          //     '',
          savedOn: this.formatCreatedDate(item?.updatedAt),
          status: this.getFormattedStatus(item?.status),
          type: this.getFormattedType(item?.type),
          applicationId: item?.applicationNo ?? ' - ',
          applicationType: this.formatAppType(item?.type),
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format('LLL');
    }
  }

  private getFormattedType(type: string) {
    if (APPLICATION_TYPE?.[type]) {
      return APPLICATION_TYPE?.[type];
    }
    return '-';
  }

  private getFormattedStatus(status: string) {
    if (status) {
      switch (status) {
        case 'EMPLOYER_DRAFT':
          return 'Employer Draft';
        case 'APPLICANT_DRAFT':
          return 'Applicant Draft';
        case 'SIGNED_BY_EMPLOYER':
          return 'Signed by Employer';
        case 'READY_TO_PAY':
          return 'Ready to Pay';
        case 'APP_FEES_PAID':
          return 'Application Fees Paid';
        case 'SUBMITTED':
          return 'Submitted';
        case 'REVIEWED':
          return 'Reviewed';
        case 'APPROVED':
          return 'Approved';
        case 'WP_FEES_PAID':
          return 'Work Permit Fees Paid';
        case 'APPLICATION_DENIED':
          return 'Application Denied';
        case 'APPEALED':
          return 'Appealed';
        default:
          return '-';
      }
    }
  }

  private formatAppType(type: string) {
    if (type) {
      switch (type) {
        case 'NEW_WORK_PERMIT':
          return 'New Work Permit';
        case 'RENEW_WORK_PERMIT':
          return 'Renew Work Permit';
        case 'MARRIAGE_EXEMPTION':
          return 'Marriage Exemption';
        default:
          return '-';
      }
    }
  }
}
